<script lang="ts">
  import InlineSVG from 'svelte-inline-svg';

  import addIcon from '../../assets/icons/add.svg';
  import removeIcon from '../../assets/icons/circle-with-cross.svg';

  import IconButton from '../icon-button/IconButton.svelte';

  export let label = '';
  export let placeholder = '';
  export let values: Array<string | null> = [null];
  export let id = '';
  export let required = false;
  export let onValidate:
    | ((value: string | null) => string | null)
    | ((value: string | null) => Promise<string | null>);

  let validationErrors: Array<string | null> = [];

  // Validate inputs on blur
  async function validateInputs() {
    if (onValidate) {
      validationErrors = await Promise.all(
        values.map(async value => {
          const error = onValidate(value);
          return error instanceof Promise ? await error : error;
        })
      );
    }
  }

  function handleAdd() {
    values = values.concat([null]);
  }
</script>

<style lang="postcss">
  .container {
    margin-bottom: 1.5rem;
  }

  .row {
    display: grid;
    grid-template-columns: 1fr 2rem;
    gap: 0.25rem;
    margin-bottom: 0.75rem;
  }

  @media (min-width: 768px) {
    .row {
      grid-template-columns: 1fr 2fr 1fr;
      align-items: start;
      gap: 1.5rem;
    }
  }

  .label {
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    align-items: center;
  }

  @media (min-width: 768px) {
    .label {
      grid-column-end: 1;
      justify-content: end;
      min-height: var(--ubilabs-input-height);
    }
  }

  @media (min-width: 768px) {
    .inputGroup {
      grid-column: 2;
    }
  }

  .inputGroup > input {
    width: 100%;
  }

  .inputGroup + :global(button) {
    margin: calc(
        (var(--ubilabs-input-height) - var(--ubilabs-icon-button-height)) / 2
      )
      0;
  }

  @media (min-width: 768px) {
    .inputGroup + :global(button) {
      margin-left: -1.25rem;
    }
  }

  .errorMessage {
    display: block;
    color: var(--ubilabs-error-color);
  }

  @media (min-width: 768px) {
    .errorMessage {
      grid-column: 2;
    }
  }
</style>

{#if values?.length}
  <div class="container">
    {#each values as value, index}
      <div class="row">
        <!-- Label & Add button -->
        {#if label && index === 0}
          <div class="label">
            <label for={`${id}-0`}>{label}{required ? '*' : ''}</label>
            <IconButton on:click={handleAdd}>
              <InlineSVG src={addIcon} />
            </IconButton>
          </div>
        {/if}

        <div class="inputGroup">
          <input
            type="text"
            {placeholder}
            id={`${id}-${index}`}
            bind:value
            on:blur={validateInputs} />

          {#if validationErrors[index]}
            <small class="errorMessage">{validationErrors[index]}</small>
          {/if}
        </div>

        <!-- Delete button  -->
        {#if index > 0}
          <IconButton
            on:click={() => {
              values = [
                ...values.slice(0, index),
                ...values.slice(index + 1, values.length)
              ];
              validationErrors = [
                ...validationErrors.slice(0, index),
                ...validationErrors.slice(index + 1, validationErrors.length)
              ];
            }}>
            <InlineSVG src={removeIcon} />
          </IconButton>
        {/if}
      </div>
    {/each}
  </div>
{/if}
